export enum SectionsType {
  Relationships = 'relationships',
  SubmissionForm = 'submission-form',
  Upload = 'upload',
  License = 'license',
  CcLicense = 'cclicense',
  collection = 'collection',
  AccessesCondition = 'accessCondition',
  SherpaPolicies = 'sherpaPolicy',
  Identifiers = 'identifiers',
  Collection = 'collection',
}
